import { AsButton } from '@adserve/adserve-react-components';
import React, { useEffect, useState } from 'react';
import CopyTypeHeaderRow from './CopyTypeHeaderRow';
import CopyTypeRow from './CopyTypeRow';

const CopyTypes = ({ campaign, staticData, onChange, readOnly }) => {
    const [totalRatio, setTotalRatio] = useState(0);
    const [manuallyOverridden, setManuallyOverridden] = useState(false);

    const padWithEmptyRows = () => {
        const rows = [];

        for (let index = campaign.copyTypes?.length; index < 7; index++) {
            rows.push(
                <CopyTypeRow
                    key={`copyTypeRow${index}`}
                    backgroundColour={index % 2 ? '#F7F7F7' : '#FFFFFF'}
                />
            );
        }

        return rows;
    };
    useEffect(() => {}, [staticData, campaign]);

    const getTotalRatio = () => {
        if (campaign.copyTypes?.length > 0) {
            return campaign.copyTypes.reduce(
                (total, copyType) => total + parseFloat(copyType.ratio),
                0
            );
        } else {
            return 100;
        }
    };

    const splitRatios = (copyTypes) => {
        const split = Math.floor((100 / copyTypes.length) * 100) / 100;

        for (let index = 0; index < copyTypes.length; index++) {
            copyTypes[index].ratio = split;
        }
    };

    useEffect(() => {
        setTotalRatio(getTotalRatio());
        if (campaign.copyTypes.length > 0) {
            const firstSplit = campaign.copyTypes[0].ratio;
            for (let index = 0; index < campaign.copyTypes.length; index++) {
                if (firstSplit !== campaign.copyTypes[index].ratio) {
                    setManuallyOverridden(true);
                    break;
                }
            }
        }
    }, [campaign.copyTypes]);

    const handleAddCopyType = (newCopyType) => {
        const ratio = 100 - getTotalRatio();
        newCopyType.ratio = ratio < 0 ? 0 : ratio;
        newCopyType.id = window.newGuid();

        const copyTypes = [...campaign.copyTypes, newCopyType];

        // if (!manuallyOverridden) {
        splitRatios(copyTypes);
        // }

        if (onChange) {
            onChange('copyTypes', copyTypes);
        }
    };

    const handleRatioChange = (updatedCopyType) => {
        const copyTypes = [...campaign.copyTypes];
        const index = copyTypes.findIndex(
            (x) =>
                x.spotTypeId === updatedCopyType.spotTypeId &&
                x.scriptFactorId === updatedCopyType.scriptFactorId
        );

        if (index > -1) {
            copyTypes[index].ratio = updatedCopyType.ratio;
            setManuallyOverridden(true);

            if (onChange) {
                onChange('copyTypes', copyTypes);
            }
        }
    };

    const handleDelete = (copyTypeId) => {
        const copyTypes = [...campaign.copyTypes];
        const index = copyTypes.findIndex((x) => x.id === copyTypeId);
        const exclusions = campaign.exclusions.filter(
            (s) => s.copyTypes[0] !== copyTypeId
        );
        campaign.exclusions = exclusions;

        if (index > -1) {
            copyTypes.splice(index, 1);

            if (!manuallyOverridden) {
                splitRatios(copyTypes);
            }

            if (onChange) {
                onChange('copyTypes', copyTypes);
            }
        }
    };

    const handleClearAll = () => {
        if (onChange) {
            onChange('copyTypes', []);
            setManuallyOverridden(false);
        }
    };

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                color: '#414141'
            }}
        >
            <span
                style={{
                    fontSize: 15,
                    fontWeight: 500,
                    marginTop: 17,
                    marginBottom: 11
                }}
            >
                {window.translate('Spot Type & Script Lengths')}
            </span>
            <div style={{ display: 'flex' }}>
                <div
                    style={{
                        display: 'grid',
                        gridTemplateAreas:
                            "'title' 'header' 'content' 'footer'",
                        gridTemplateRows: '33px 81px auto 11px',
                        gridTemplateColumns: '4fr 1fr',
                        width: '95%',
                        border: '1px solid #E3E3E3'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            paddingLeft: 57
                        }}
                    >
                        <span style={{ fontSize: 12 }}>
                            {window.translate(
                                'Select spot types, script lengths, positions and % ratio distributions below.'
                            )}
                        </span>
                    </div>
                    <div />
                    <div
                        style={{
                            display: 'flex',
                            borderTop: '1px solid #E3E3E3',
                            gridColumnStart: 1,
                            gridColumnEnd: 3
                        }}
                    >
                        <CopyTypeHeaderRow
                            campaignId={campaign.id}
                            staticData={staticData}
                            onAddCopyType={handleAddCopyType}
                            campaign={campaign}
                            readOnly={readOnly}
                        />
                    </div>

                    <div>
                        {campaign.copyTypes?.map((copyType, index) => (
                            <CopyTypeRow
                                key={`copyType${index}`}
                                backgroundColour={
                                    index % 2 ? '#F7F7F7' : '#FFFFFF'
                                }
                                staticData={staticData}
                                copyType={copyType}
                                onRatioChange={handleRatioChange}
                                onDelete={handleDelete}
                                readOnly={readOnly}
                            />
                        ))}
                        {padWithEmptyRows()}
                    </div>

                    <div />

                    <div style={{ borderTop: '1px solid #E3E3E3' }} />
                    <div />
                </div>
            </div>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '85%'
                }}
            >
                <AsButton
                    useSecondaryStyle
                    style={{
                        width: 120,
                        fontSize: 15,
                        fontWeight: 'bold',
                        marginTop: 20,
                        marginBottom: 20
                    }}
                    handleClick={handleClearAll}
                    disabled={readOnly}
                >
                    {window.translate('Clear All')}
                </AsButton>
                <div
                    style={{
                        boxSizing: 'border-box',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        height: 34,
                        paddingLeft: 22,
                        paddingRight: 17,
                        ...(Math.abs(100 - totalRatio) > 0.1
                            ? {
                                  backgroundColor: '#FFF3F3',
                                  border: '1px solid #C40606'
                              }
                            : null)
                    }}
                >
                    <span
                        style={{
                            fontSize: 12,
                            marginRight: 20,
                            ...(Math.abs(100 - totalRatio) > 0.1
                                ? { color: '#C40404' }
                                : null)
                        }}
                    >
                        {window.translate('Split values must total 100%')}
                    </span>
                    <span style={{ fontSize: 14, fontWeight: 500 }}>
                        {window.translate('Total: %')}
                    </span>
                    <span
                        style={{
                            fontSize: 15,
                            fontWeight: 500,
                            width: 55,
                            textAlign: 'right'
                        }}
                    >
                        {totalRatio.toFixed(2)}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default CopyTypes;
